import { Component, ViewEncapsulation, output } from '@angular/core';

@Component({
    selector: 'ap-list-item-button',
    templateUrl: './list-item-button.html',
    styleUrls: ['./list-item-button.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class ApListItemButtonComponent {
    /**
     * Eventemitter that is emitted on click, keyboard enter and keyboard space
     */
    public readonly itemClicked = output<void>();

    protected onItemClicked(): void {
        this.itemClicked.emit(undefined);
    }
}
